import { removeProp } from '@ipfabric/utils/fp/prop';
import { isTopologyGraphMetadata } from 'components/Graph/GraphState';
import { applyTopologySettings } from 'components/Graph/commands/applyTopologySettings';
import { clearSettings } from 'components/Graph/helpers/clearSettings';
import { setPresetDraftState } from 'components/Graph/helpers/setPresetDraftState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/function';

export const updateTopologyPreset: GraphCommandFactory =
  (cmdContext, dispatch) => async () => {
    try {
      const {
        layoutSettings: { presetDraft },
        graphMetadata,
      } = cmdContext.getState();
      cmdContext.updateState(setPresetDraftState('updating'));
      await cmdContext.api.request({
        url: `/graphs/presets/${encodeURIComponent(presetDraft.id)}`,
        method: 'PUT',
        data: pipe(presetDraft, clearSettings, removeProp('id', 'factory')),
      });
      cmdContext.updateState((draft) => {
        const foundGroupIndex = draft.layoutSettings.presets.findIndex(
          (p) => p.id === presetDraft.id,
        );
        if (foundGroupIndex > -1) {
          draft.layoutSettings.presets[foundGroupIndex] = presetDraft;
        }
      });
      cmdContext.showNotification({
        type: 'success',
        message: cmdContext.msg.canvasGraph.request.presetSaved,
      });

      if (!isTopologyGraphMetadata(graphMetadata)) {
        // no topology graph loaded so we don't apply settings
        return;
      }

      dispatch(applyTopologySettings);
    } finally {
      cmdContext.updateState(setPresetDraftState('idle'));
    }
  };
